import React from "react";
import aboutUs from "../pictures/about-denjneshin.svg";

export const AboutUs = () => {
  return (
    <section className="about-us p-4 w-100">
      <img className="mb-2" src={aboutUs} alt=""  />
      <p>کافه دنج نشین محلی است برای آسان تر کردن روش سفارش و تحویل و حساب کردن از جمله بهترین قابلیت های این برنامه میتوان به تقسیم کردن خودکار قیمت بین شما و همراهانتان و نیز همچنین سیستم دنجنشین کافه ها که کافه مورد علاقه شما رو به شیوه ای سودمند برایتان در نظر میگیرد.</p>
      <p>این برنامه همچنین برای سفارش و تحویل درب منزل نیز طراحی شده است.</p>
      <p>راحتی شما در استفاده از این برنامه اولیت ماست که در آن سعی داریم ... </p>
    </section>
  );
};
